import {
    getNumberOfSurveyResponses,
    getSurveyFreeTextResponses,
    getSurveyResponses,
} from "../services/survey/survey.service";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useGetSurveyResponses = (surveyId, languageMasterId) => {
    const { t, i18n } = useTranslation();
    const [surveyResponses, setSurveyResponses] = useState();
    const [surveyFreeTextResponses, setSurveyFreeTextResponses] = useState([]);
    const [surveyNumberOfResponses, setSurveyNumberOfResponses] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchSurveyResponses = async (languageId) => {
        setLoading(true);
        try {
            const response = await getSurveyResponses(surveyId, languageId);
            if(typeof(response?.data) === 'string'){
                if(response?.data.includes("No responses found")){
                    setSurveyResponses(response?.data || null);
                }else {
                    toast.error("No survey available in this language.", { position: "top-center", theme: "dark" });
                }
            } else {
                setSurveyResponses(response?.data || null);
            }
        } catch (error) {
            console.error("Error fetching survey responses:", error);
        } finally {
            setLoading(false);
        }
    };
    const fetchUserResponses = async (languageId) => {
        setLoading(true);
        try {
            const response = await getSurveyFreeTextResponses(surveyId, languageId);
            setSurveyFreeTextResponses(response?.data || []);
        } catch (error) {
            console.error("Error fetching user responses:", error);
        } finally {
            setLoading(false);
        }
    };
    const fetchTotalResponses = async () => {
        setLoading(true);
        try {
            const response = await getNumberOfSurveyResponses(surveyId);
            setSurveyNumberOfResponses(response?.data || 0);
        } catch (error) {
            console.error("Error fetching user responses:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (surveyId) {
            const sessionLanguageDetails = JSON.parse(sessionStorage.getItem("selectedLanguageDetails") || "{}");
            let languageId = 1;
            if(i18n.language === sessionLanguageDetails.name){
                languageId = sessionLanguageDetails.id;
            }
            fetchSurveyResponses(languageId);
            fetchUserResponses(languageId);
            fetchTotalResponses();
        }
    }, [surveyId, i18n.language]);

    return [
        surveyResponses,
        surveyFreeTextResponses,
        surveyNumberOfResponses,
        loading,
    ];
};

export default useGetSurveyResponses;
